import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2114560a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "SendApplyInfo" }
const _hoisted_2 = { class: "info block-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-tit" }, "申报详情", -1))
const _hoisted_4 = { class: "block-con" }
const _hoisted_5 = { class: "pics" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "submit-btn"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "submit-btn"
}

import { projectItem, flowsItem, Approve } from '@/apis/base'
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const type_name = ref('--')
const sendDetails = ref({
  explain: '', // 说明
  phone: '', // 联系电话
  liable_person: '', // 联系人
  start_date: '', // 计划发货时间
  end_date: '', // 供货截止时间
  address: '', // 项目地址
  tabsActive: 0, // 已发起
  pics: null,
  type_id: 0, // 项目类型
  item_id: 0, // 详情id
  approve: {} as Approve,
  project: {} as projectItem,
  flows: Array<flowsItem>()
})
const showBottom = ref(false)

const StaffInfo = ref({
  id: 0,
  name: '',
  avatar: ''
})
onMounted(() => {
  StaffInfo.value = JSON.parse(localStorage.getItem('STAFFINFO'))
  sendDetails.value = JSON.parse(router.currentRoute.value.query.data.toString())
  type_name.value = router.currentRoute.value.query.type_name.toString()
  let botton: any = router.currentRoute.value.query.button
  showBottom.value = botton
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_DetailTitle = _resolveComponent("DetailTitle")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_PreviewPicture = _resolveComponent("PreviewPicture")!
  const _component_ApprovalProcess = _resolveComponent("ApprovalProcess")!
  const _component_BottomButtonTwo = _resolveComponent("BottomButtonTwo")!
  const _component_BottomButtonOne = _resolveComponent("BottomButtonOne")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createVNode(_component_DetailTitle, {
      approve: sendDetails.value.approve
    }, null, 8, ["approve"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_cell_group, {
          title: "项目名称",
          border: false,
          class: "mx-box"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              title: sendDetails.value?.project?.name,
              size: "large"
            }, null, 8, ["title"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_cell_group, {
          title: "发货情况",
          border: false,
          class: "mx-box"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              title: "项目地址",
              value: sendDetails.value?.address
            }, null, 8, ["value"]),
            _createVNode(_component_van_cell, {
              title: "计划发货时间",
              value: sendDetails.value.start_date
            }, null, 8, ["value"]),
            _createVNode(_component_van_cell, {
              title: "供货截止时间",
              value: sendDetails.value.end_date
            }, null, 8, ["value"]),
            _createVNode(_component_van_cell, {
              title: "现场负责人",
              value: sendDetails.value.liable_person
            }, null, 8, ["value"]),
            _createVNode(_component_van_cell, {
              title: "联系电话",
              value: sendDetails.value.phone
            }, null, 8, ["value"]),
            _createVNode(_component_van_cell, {
              title: "其他说明：",
              value: sendDetails.value.explain
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        (sendDetails.value.pics)
          ? (_openBlock(), _createBlock(_component_van_cell_group, {
              key: 0,
              title: "图片",
              border: false
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_PreviewPicture, {
                    imgs: sendDetails.value.pics,
                    radius: 5,
                    width: 65,
                    height: 65
                  }, null, 8, ["imgs"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ApprovalProcess, {
      flows: sendDetails.value.flows
    }, null, 8, ["flows"]),
    (sendDetails.value.tabsActive == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (sendDetails.value.approve.approve_staff?.id === StaffInfo.value.id && sendDetails.value.approve.state == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (showBottom.value)
                  ? (_openBlock(), _createBlock(_component_BottomButtonTwo, {
                      key: 0,
                      typeId: sendDetails.value.type_id,
                      itemId: sendDetails.value.item_id
                    }, null, 8, ["typeId", "itemId"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (sendDetails.value.tabsActive == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (sendDetails.value.approve.staff_id === StaffInfo.value.id && sendDetails.value.approve.state == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (showBottom.value)
                  ? (_openBlock(), _createBlock(_component_BottomButtonOne, {
                      key: 0,
                      typeId: sendDetails.value.type_id,
                      itemId: sendDetails.value.item_id
                    }, null, 8, ["typeId", "itemId"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})